const translations = {
    saveReport: 'Save Report'
};

export default translations;
